import styled from "styled-components";

export const Row = styled.div<{ $gap?: number }>`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ $gap }) => $gap ?? 0}px;
`;